module.exports = __webpack_public_path__ + "static/media/ImmaginePromozione.5caf35e4.png";